import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue";
import _imports_0 from '../assets/tada.gif';
const _hoisted_1 = { class: "success-page" };
const _hoisted_2 = { class: "hero-container" };
const _hoisted_3 = {
    key: 0,
    class: "policy-card-container"
};
const _hoisted_4 = { class: "features-container" };
const _hoisted_5 = {
    key: 0,
    class: "feature-item"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = { class: "anchor-bottom-no-nav" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useBanking } from '@/composables/useBanking';
import { getBrandLogoUrl } from '@/utils/helpers';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import AccountListItem from './elements/AccountListItem.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'BankAccountSuccessPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getBankAccount } = useBanking();
        const animateEmoji = ref(false);
        const showCard = ref(false);
        const featuresShown = ref(0);
        const account = ref(null);
        const features = [
            { icon: 'icon-document', text: 'Keep your account details safe,<br/>all in one place' },
            { icon: 'icon-calendar', text: 'See this balance alongside<br/>your other accounts' },
            { icon: 'icon-chat', text: 'Chat with our assistant to<br/>understand your money' },
        ];
        const id = computed(() => route.query.id);
        const allAnimationsComplete = computed(() => featuresShown.value >= features.length);
        function handleDone() {
            router.push('/money');
        }
        function startAnimations() {
            setTimeout(() => { animateEmoji.value = true; }, 100);
            setTimeout(() => { showCard.value = true; }, 2000);
            features.forEach((_, i) => {
                setTimeout(() => { featuresShown.value = i + 1; }, 2800 + i * 600);
            });
        }
        onMounted(() => {
            if (id.value) {
                getBankAccount(id.value, (result) => {
                    account.value = result ?? state.bankAccount;
                    startAnimations();
                }, true);
            }
            else {
                startAnimations();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    border: "0",
                    bgcolor: "transparent"
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "title" }, "Account added successfully", -1)),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["emoji-container", { 'animate': animateEmoji.value, 'fade-out': showCard.value }])
                        }, _cache[0] || (_cache[0] = [
                            _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Celebration",
                                class: "party-emoji"
                            }, null, -1)
                        ]), 2),
                        _createVNode(_Transition, { name: "fade-slide" }, {
                            default: _withCtx(() => [
                                (showCard.value && account.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createVNode(AccountListItem, {
                                            "provider-name": account.value.bank?.name || 'Bank',
                                            line1: account.value.displayName || account.value.accountType?.prettyName || 'Account',
                                            line2: account.value.accountNumber || '',
                                            label: "Balance",
                                            value: _unref(state).formatter.format(account.value.balance || 0),
                                            "avatar-url": account.value.bank?.logoUri || _unref(getBrandLogoUrl)(account.value.bank?.name)
                                        }, null, 8, ["provider-name", "line1", "line2", "value", "avatar-url"])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(features, (feature, i) => {
                            return _createVNode(_Transition, {
                                name: "fade-slide",
                                key: i
                            }, {
                                default: _withCtx(() => [
                                    (featuresShown.value > i)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                            _createElementVNode("img", {
                                                src: require(`../assets/${feature.icon}.svg`),
                                                alt: "",
                                                class: "feature-icon-img"
                                            }, null, 8, _hoisted_6),
                                            _createElementVNode("div", {
                                                class: "feature-text",
                                                innerHTML: feature.text
                                            }, null, 8, _hoisted_7)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 2
                            }, 1024);
                        }), 64))
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(MGButton, {
                            text: "Done",
                            fullWidth: true,
                            disabled: !allAnimationsComplete.value,
                            onClick: handleDone
                        }, null, 8, ["disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
